import React, { useState, useEffect, useRef } from "react";
import * as Style from "./styledComponents/PersonalInstruction";
import Safe from "../assets/images/DeathModuleNew/ATM.png";
import SeeMore from "../assets/images/DeathModuleNew/more_horiz.png";
import { saveAs } from "file-saver";
import menuIcon from "../assets/images/DeathModuleNew/Menu.png";
import helpIcon from "../assets/images/DeathModuleNew/IC_Help.png";
import Loader from "../components/styled-components/loader/loader";
import AddModal from "./styledComponents/Modal/AddModal";
import UpdateModal from "./styledComponents/Modal/UpdateModal";
import List from "./styledComponents/Table/List";
import { Modal } from "antd";
import DEATH_API from "../apis/death.api";
import MODULE_API from "../apis/module.api";
import ViewModal from "./styledComponents/Modal/ViewModal";
import swal from "sweetalert";
import moment from "moment";
import axios from "axios";
import { ToolTipCreator } from "../helpers/ToolTipCreator";

export const PasswordList = (props) => {
  const data = [
    {
      Name: "Testing",
      Phone: "Testing",
      Email: "Testing",
      address: "Testing",
      Director: "Testing",
      location: " Testing",
      Paidfor: "Testing",
      paid: "Testing",
      Notes: "New Testing",
    },
    {
      Name: "Testing",
      Phone: "Testing",
      Email: "Testing",
      address: "Testing",
      Director: "Testing",
      location: " Testing",
      Paidfor: "Testing",
      paid: "Testing",
      Notes: "New Testing",
    },
    {
      Name: "Testing",
      Phone: "Testing",
      Email: "Testing",
      address: "Testing",
      Director: "Testing",
      location: " Testing",
      Paidfor: "Testing",
      paid: "Testing",
      Notes: "New Testing",
    },
  ];
  const cols = [
    {
      title: "Site/App/Program",
      dataIndex: "appName",
      render: (record) => (record ? record : "N/A"),
    },
    {
      title: "UserName",
      dataIndex: "userName",
      render: (record) => (record ? record : "N/A"),
    },
    {
      title: "Who's Password",
      dataIndex: "passwordFor",
      render: (record) => (record ? record : "N/A"),
    },
    {
      title: "Password Hint",
      dataIndex: "passwordHint",
      render: (record) => (record ? record : "N/A"),
    },

    {
      title: "Website URL",
      dataIndex: "appUrl",
      render: (record) => (record ? record : "N/A"),
    },
    {
      title: "2FA",
      dataIndex: "twoFactor",
      render: (record) => (record ? record : "N/A"),
    },
    {
      title: "Pin",
      dataIndex: "pin",
      render: (record) => (record ? record : "N/A"),
    },

    {
      title: "Security Question",
      dataIndex: "securityQuestion",
      render: (record) => (record ? record : "N/A"),
    },
    {
      title: "Answer",
      dataIndex: "answer",
      render: (record) => (record ? record : "N/A"),
    },
    {
      title: "Notes",
      dataIndex: "note",
      render: (record) => (record ? record : "N/A"),
    },

    {
      title: "Action",
      render: (record, index) => {
        // console.log("index...>>>",record.idx);
        return (
          <div>
            <div
              onClick={() => {
                setDropdown(!dropdown);
                getSelectedRow(record.id);
              }}
              style={{
                cursor: "pointer",
                marginRight: "1rem",
                padding: "0px 16px",
                width: "5px",
              }}>
              <img src={menuIcon} alt="menuIcon"></img>
            </div>
            {dropdown && selectedIndex === record.id && (
              <>
                <div
                  onClick={() => {
                    setDropdown(false);
                  }}
                  className=""
                  style={{
                    position: "fixed",
                    width: "100vw",
                    height: "100vh",
                    background: "black",
                    opacity: "0.1",
                    top: "0",
                    left: "0",
                    right: "0",
                    bottom: "0",
                    zIndex: "999",
                  }}></div>

                <div class="dropdown" style={{ zIndex: "9999" }}>
                  <ul className="dropdownul">
                    {props.role !== "protrustee" && (
                      <li
                        className="liHover"
                        onClick={() => {
                          deleteSelectedRow(record.id);
                          setDropdown(false);
                        }}>
                        Delete
                      </li>
                    )}
                    {props.role !== "protrustee" && (
                      <li
                        className="liHover"
                        onClick={() => {
                          setShowUpdateModal(true);
                          setDropdown(false);
                        }}>
                        Update
                      </li>
                    )}
                    <li
                      className="liHover"
                      onClick={() => {
                        setShowViewModal(true);
                        setDropdown(false);
                      }}>
                      View
                    </li>
                  </ul>
                </div>
              </>
            )}{" "}
          </div>
        );
      },
    },
  ];

  const fields = [
    {
      title: "Site / App / Program or Printed Sheet",
      type: "input",
      index: "SiteAppProgram",
    },
    {
      title: "User Name",
      type: "input",
      index: "UserName",
    },
    {
      title: "Who's Password",
      type: "input",
      index: "WhosPassword",
    },
    {
      title: "Password Hint",
      type: "input",
      index: "PasswordHint",
    },
    {
      title: "Website URL",
      type: "input",
      index: "WebsiteURL",
    },
    {
      title: "2FA",
      type: "input",
      index: "TwoFA",
    },
    {
      title: "Pin",
      type: "input",
      index: "Pin",
    },
    {
      title: "Security Question",
      type: "input",
      index: "SecurityQuestion",
    },
    {
      title: "Answer",
      type: "input",
      index: "Answer",
    },
    {
      title: "Notes",
      type: "textarea",
      index: "Notes",
    },
  ];

  const update_fields = [
    {
      title: "Site / App / Program or Printed Sheet",
      type: "input",
      index: "appName",
    },
    {
      title: "User Name",
      type: "input",
      index: "userName",
    },
    {
      title: "Who's Password",
      type: "input",
      index: "passwordFor",
    },
    {
      title: "Password Hint",
      type: "input",
      index: "passwordHint",
    },
    {
      title: "Website URL",
      type: "input",
      index: "appUrl",
    },
    {
      title: "2FA",
      type: "input",
      index: "twoFactor",
    },
    {
      title: "Pin",
      type: "input",
      index: "pin",
    },
    {
      title: "Security Question",
      type: "input",
      index: "securityQuestion",
    },
    {
      title: "Answer",
      type: "input",
      index: "answer",
    },
    {
      title: "Notes",
      type: "textarea",
      index: "note",
    },
  ];

  useEffect(() => {
    console.log("calling api");
    getPasswordList();
    getPasswordSheet();
  }, []);

  // upload password sheets
  const [fileUpload, setFileUpload] = useState(null);
  const [dropdownFile, setDropdownFile] = useState(false);

  const handleUploadFile = async (fileUrl, fileName) => {
    const ID = localStorage.getItem("accessId");
    try {
      setLoading(true);
      let res = await DEATH_API.addPasswordSheet({
        clientPasswordDocument: fileUrl,
        clientPasswordFileName: fileName,
        clientPasswordDate: new Date(),
      });
      if (res && res.status === 200) {
        await getPasswordSheet();
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };
  const getPasswordSheet = async () => {
    const ID = localStorage.getItem("accessId");
    try {
      setLoading(true);
      let dataFile = await DEATH_API.getPasswordSheet(ID);
      if (dataFile && dataFile.data) {
        setFileUpload(dataFile.data);
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };
  const handleRemoveFile = async () => {
    try {
      setLoading(true);
      let api_res = await DEATH_API.updatePasswordSheet({
        clientPasswordDocument: "",
        clientPasswordFileName: "",
        clientPasswordDate: null,
      });
      if (api_res && api_res.status === 200) {
        await getPasswordSheet();
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };

  const handleImageUpload = async (event) => {
    const fileSize = event.target.files[0].size / (1024 * 1000); // in MB
    console.log("fileSize in mb", fileSize);
    let uploadFile = event.target.files[0];
    if (uploadFile) {
      const formData = new FormData();
      formData.append("file", uploadFile);
      console.log("item.file", uploadFile);
      const name = uploadFile.name;
      const lastDot = name.lastIndexOf(".");
      const fileName = name.substring(0, lastDot);
      const ext = name.substring(lastDot + 1);
      setLoading(true);
      const resdata = await MODULE_API.uploadFile({
        fileExt: ext,
        contentType: uploadFile.type,
      });
      const resupload = await axios.put(resdata.uploadUrl, uploadFile, {
        headers: { "Content-type": uploadFile.type },
      });
      const res = resdata.uploadUrl.split("?")[0];
      console.log("image", res);
      await handleUploadFile(res, fileName);
      setLoading(false);
    }
  };
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [tooltipModal, setTooltipModal] = useState(false);
  const [listofPassword, setListofPassword] = useState([]);
  const [OTP_Status, setOTP_Status] = useState(false);
  const [loading, setLoading] = useState(false);
  const [userData, setUserData] = useState({});
  const [message, setMessage] = useState("");
  const [dropdown, setDropdown] = useState(false);

  const [showAddModal, setShowAddModal] = useState(false);
  const [showUpdateModal, setShowUpdateModal] = useState(false);
  const [addData, setaddData] = useState({});
  const [updateObject, setUpdateObject] = useState(null);
  const [selectedIndex, setSelectedIndex] = useState(null);
  const [dropDownPassword, setDropDownPassword] = useState(false);

  const [showViewModal, setShowViewModal] = useState(false);

  const fileRef = useRef(null);

  const openFileRef = () => {
    const files = fileRef.current.click();
    if (files) {
      console.log("files inside..", files);
    }
  };

  const handelCloseViewModal = () => {
    setShowViewModal(false);
  };

  const handelCloseModal = () => {
    setShowAddModal(false);
  };
  const handelCloseUpdateModal = () => {
    setShowUpdateModal(false);
  };
  const handlechange = (e) => {
    console.log("e", e.target);
    e.preventDefault();
    const { name, value } = e.target;

    setaddData({
      ...addData,
      [name]: value,
    });
  };
  const handleDocumentChange = (name, value) => {
    // console.log("e", e.target);
    // e.preventDefault();
    // const { name, value } = e.target;

    setaddData({
      ...addData,
      [name]: value,
    });
  };
  const handleDatePickerChange = (name, value) => {
    setaddData({
      ...addData,
      [name]: value,
    });
  };
  const handleRadioChange = (name, value) => {
    setaddData({
      ...addData,
      [name]: value,
    });
  };
  const handleUpdatechange = (e) => {
    console.log("e", e.target);
    e.preventDefault();
    const { name, value } = e.target;

    setUpdateObject({
      ...updateObject,
      [name]: value,
    });
  };
  const handleUpdateDocumentChange = (name, value) => {
    // console.log("e", e.target);
    // e.preventDefault();
    // const { name, value } = e.target;

    setUpdateObject({
      ...updateObject,
      [name]: value,
    });
  };
  const handleUpdateDatePickerChange = (name, value) => {
    setUpdateObject({
      ...updateObject,
      [name]: value,
    });
  };
  const handleUpdateRadioChange = (name, value) => {
    setUpdateObject({
      ...updateObject,
      [name]: value,
    });
  };
  const SubmitUpdate = () => {
    console.log("updated object", updateObject);
    updatePasswords();
    handelCloseUpdateModal();
  };
  const submitData = () => {
    console.log("submit data", addData);
    createPasswords();
    handelCloseModal();
  };

  const createPasswords = async () => {
    // checxk if already formData contains some data then initialize it with empty

    var arr = [addData];
    try {
      let data = arr;
      if (Array.isArray(data) && data.length > 0) {
        setLoading(true);
        let api_res = await DEATH_API.addPasswords({
          listOfPasswordsForm: data.map((item) => {
            return {
              appName: item["Site / App / Program or Printed Sheet"],
              userName: item["User Name"],
              passwordFor: item["Who's Password"],
              passwordHint: item["Password Hint"],
              appUrl: item["Website URL"],
              twoFactor: item["2FA"],
              pin: +item.Pin,
              note: item.Notes,
              securityQuestion: item["Security Question"],
              answer: item.Answer,
            };
          }),
        });
        setLoading(false);
        getPasswordList();

        return api_res;
      }
    } catch (error) {
      console.log(error);
      throw new Error(error);
    }
  };
  const updatePasswords = async () => {
    try {
      let obj = {
        ...updateObject,
        appName: updateObject.appName,
        userName: updateObject.userName,
        passwordFor: updateObject.passwordFor,
        passwordHint: updateObject.passwordHint,
        appUrl: updateObject.appUrl,
        twoFactor: updateObject.twoFactor,
        pin: +updateObject.pin,
        note: updateObject.note,
        securityQuestion: updateObject.securityQuestion,
        answer: updateObject.answer,
      };

      setLoading(true);
      await DEATH_API.updatePasswords(obj.id, {
        ...obj,
      });
      setLoading(false);
      getPasswordList();
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };
  const deleteSelectedRow = async (idx) => {
    swal({
      title: "Are you sure?",
      text: "Are you sure you want to delete this?",
      dangerMode: true,
      buttons: ["No, cancel it!", "Yes, delete it!"],
      icon: "warning",
      type: "warning",
      closeOnConfirm: false,
      closeOnCancel: false,
    }).then(async function (isConfirm) {
      // Redirect the user
      if (isConfirm) {
        try {
          setLoading(true);
          await DEATH_API.deletePassword(idx);
          const updatedRows = listofPassword.filter((row, index) => {
            return row.id != idx;
          });
          setListofPassword(updatedRows);

          setLoading(false);
          getPasswordList();
        } catch (error) {
          setLoading(false);
          console.log(error);
        }
        setTimeout(async () => {
          // that.props.handleLoader()
          setLoading(true);
          swal("Deleted!", "Your file has been deleted.", "success");
          setLoading(false);
        }, 0);
      } else {
        swal("Cancelled", "Your file is safe :)", "error");
      }
    });
  };
  const getSelectedRow = (idx, rows, name) => {
    console.log("idx>>>", idx);
    setSelectedIndex(idx);
    // get selected row (this will return array of object)
    let selectedRow = listofPassword.filter((row, index) => {
      return row.id == idx;
    });
    // get first and only element from list and store it in update object
    console.log("selectedRow[0]", selectedRow[0]);
    setUpdateObject(selectedRow[0]);
  };
  const getPasswordList = async () => {
    if (props.role == "protrustee") {
      isSecondPasswordGranted();
    }

    if (props.role !== "protrustee") {
      if (!localStorage.getItem("otp")) {
        localStorage.setItem("otp", "");
      }
      if (localStorage.getItem("otp") === "") {
        showModal();
      } else {
        // this.props.handleLoader();
        setLoading(true);
        console.log("this.state.userData", userData);
        if (localStorage.getItem("otp")) {
          const ID = localStorage.getItem("accessId");

          let data = await DEATH_API.fetchPasswords(
            localStorage.getItem("otp"),
            ID
          );
          if (data.message === "This is an expired OTP") {
            showModal();
          } else {
            if (data && data.data) {
              setListofPassword(data.data);
            }
          }
          setLoading(false);
          // this.props.handleLoader();
        }
      }
    }
  };

  const isSecondPasswordGranted = async () => {
    try {
      // this.props.handleLoader();
      setLoading(true);
      const ID = localStorage.getItem("accessId");
      let data = await DEATH_API.getSecondPasswordStatus(ID);
      // this.props.handleLoader();
      setLoading(false);

      console.log("data.message", data.date.secondPasswordGranted);
      setOTP_Status(data.date.secondPasswordGranted);
      // this.setState({
      //   OTP_Status: data.date.secondPasswordGranted,
      // });
      if (data.date.secondPasswordGranted === 1) {
        if (!localStorage.getItem("otp")) {
          localStorage.setItem("otp", "");
        }
        if (localStorage.getItem("otp") === "") {
          showModal();
        } else {
          // this.props.handleLoader();
          setLoading(true);
          console.log("this.state.userData", userData);
          if (localStorage.getItem("otp")) {
            const ID = localStorage.getItem("accessId");

            let data = await DEATH_API.fetchPasswords(
              localStorage.getItem("otp"),
              ID
            );
            if (data.message === "This is an expired OTP") {
              showModal();
            } else {
              if (data && data.data) {
                setListofPassword(data.data);
              }
            }
            setLoading(false);
            // this.props.handleLoader();
          }
        }
      }

      if (data.date.secondPasswordGranted === 0) {
        setLoading(true);
        // this.props.handleLoader();
        swal(
          "Restricted!",
          "You have not been granted access to this information.",
          "warning"
        );
        setLoading(false);

        // this.props.handleLoader();
      }
    } catch (error) {
      console.log("e ", error);
    }
  };
  const showTooltipModal = () => {
    setTooltipModal(true);
  };

  const handleTooltipCancel = () => {
    setTooltipModal(false);
  };
  const handleOk = async () => {
    console.log("login......", userData);
    let message = {};
    let data = {};
    if (userData !== undefined) {
      // this.props.postSavedOtp(this.state.userData.otp)
      // localStorage.setItem("otp", userData.otp);
      // this.props.handleLoader();
      setLoading(true);

      try {
        const ID = localStorage.getItem("accessId");
        data = await DEATH_API.fetchPasswords(userData && userData.otp, ID);
        message = data;
        setMessage(data);
        // this.setState({ message: data })
        console.log("data passwordlist", data);
        if (data && data.status === 200) {
          console.log("userData.otp", userData);
          localStorage.setItem("otp", userData.otp);

          if (data && data.data) {
            setListofPassword(data.data);
          }
        }
        setLoading(false);
        if (userData.otp) {
          setIsModalOpen(false);
        } else {
          swal("Oops!", "Invalid OTP", "error");
        }
      } catch (error) {
        console.log("here in catch", error);
      }
    }
    if (data.status === 400 && data.message === "Please enter a valid OTP") {
      swal("Oops!", "Please enter a valid OTP", "error");
      setIsModalOpen(true);
    }
  };
  const handleCancel = () => {
    setIsModalOpen(false);
    // this.props.postSavedOtp("")
    localStorage.setItem("otp", "");
  };

  const downloadTemplate = async () => {
    try {
      setLoading(true);
      const res = await DEATH_API.getPasswordTemplates("password");
      setLoading(false);
      console.log("res.....", res.url);
      const customFileName = "List of Passwords Template.csv";

      const response = await fetch(res.url);
      const blob = await response.blob();

      saveAs(blob, customFileName);
    } catch (error) {
      console.log(error);
    }
  };
  const downloadFileRef = async () => {
    try {
      setLoading(true);
      const res = await DEATH_API.exportPasswordSheet("password");
      setLoading(false);
      console.log("res..... of downloainf", res.url);
      const customFileName = "List of Passwords.csv";

      const response = await fetch(res.url);
      const blob = await response.blob();

      saveAs(blob, customFileName);
    } catch (error) {
      console.log(error);
    }
  };

  const showModal = async () => {
    setIsModalOpen(true);

    // this.setState({
    //   isModalOpen: true,
    // });
    // console.log("userData", this.state.userData);
    try {
      const ID = localStorage.getItem("accessId");

      let data = await DEATH_API.configOtp(ID);
      console.log("data>>", data);
      swal(data.message);
      // console.log("data.message",data.message)
    } catch (error) {
      console.log("e ", error);
    }
  };

  return (
    <div>
      {" "}
      <Modal visible={isModalOpen} footer={null} closable={false} centered>
        <div style={{ marginTop: "20px" }}>
          {/* <div style={{padding:"50px",background:"black",overflow:"hidden"}}>hellow</div> */}
          <h3 style={{ color: "#4d5e80", marginBottom: "10px" }}>
            {" "}
            List of Passwords
          </h3>
          <div className="">
            <h2 className="otp-heading" style={{ color: "#4d5e80" }}>
              This passcode provides another layer of security for your list of
              passwords. The passcode is only valid for this session.
            </h2>
            <div>
              <Style.Input
                onChange={(e) => {
                  e.persist();
                  setUserData((prevFormData) => ({
                    ...prevFormData,
                    [e.target.name]: e.target.value,
                  }));
                }}
                id="otp"
                type="text"
                // pattern="[0-9]{10}"
                pattern="[0-9.]+"
                // pattern="[0-9]+"
                // pattern="\d*"
                // maxlength="4"
                maxLength={6}
                placeholder="***OTP***"
                name="otp"
              />

              <Style.ResendButton
                onClick={async () => {
                  console.log();
                  const ID = localStorage.getItem("accessId");
                  setLoading(true);
                  let data = await DEATH_API.configOtp(ID);
                  console.log("data>>", data);
                  swal(data.message);
                  setLoading(false);
                }}>
                Resend OTP
              </Style.ResendButton>

              <Style.WrapperButtons>
                <Style.CancelButton
                  id="stop"
                  onClick={() => {
                    handleCancel();
                  }}>
                  Cancel
                </Style.CancelButton>
                <Style.SaveButton onClick={handleOk}>Done</Style.SaveButton>
              </Style.WrapperButtons>
            </div>
          </div>
        </div>
        <Loader isLoading={loading} />
      </Modal>
      <Modal
        centered
        visible={tooltipModal}
        footer={null}
        onCancel={handleTooltipCancel}>
        <Style.ModalTitle> List of Passwords</Style.ModalTitle>
        <div style={{}}>
          <div className="">
            <Style.ModalDetails>
              We live in a digital age and accessing information often requires
              passwords. The Plan Creator might leave nothing on this subject,
              maybe a few handwritten items, or very detailed listings. Plan
              Creators might choose to link to a third-party password manager or
              leave a password protected PDF. The myriad of choices is many, and
              this program feature allows for an easy repository or gateway for
              password accessibility after death. The Passwords module is only
              accessible via 2FA code sent to phone via text (SMS), and only
              upon plan activation so that privacy is ensured while the Plan
              Creators are alive.
            </Style.ModalDetails>
          </div>
        </div>
      </Modal>
      <input
        type="file"
        id="file"
        accept=".csv, application/vnd.ms-excel, text/csv"
        ref={fileRef}
        style={{ display: "none" }}
        onChange={async (event) => {
          try {
            const formData = new FormData();
            formData.append("file", event.target.files[0]);
            setLoading(true);
            const res = await DEATH_API.uploadPasswordSheet(formData);
            setLoading(false);
            getPasswordList();
          } catch (error) {
            console.log(error);
          }
        }}
      />
      {showAddModal && (
        <AddModal
          show={showAddModal}
          close={handelCloseModal}
          fields={fields}
          modalTitle="Add New Password"
          handlechange={handlechange}
          submitData={submitData}
          handleDocumentChange={handleDocumentChange}
          handleDatePickerChange={handleDatePickerChange}
          handleRadioChange={handleRadioChange}
        />
      )}
      {showUpdateModal && (
        <UpdateModal
          show={showUpdateModal}
          close={handelCloseUpdateModal}
          fields={update_fields}
          modalTitle="Update Passsword"
          handlechange={handleUpdatechange}
          submitData={SubmitUpdate}
          handleDocumentChange={handleUpdateDocumentChange}
          handleDatePickerChange={handleUpdateDatePickerChange}
          handleRadioChange={handleUpdateRadioChange}
          obj={updateObject}
        />
      )}
      {showViewModal && (
        <ViewModal
          show={showViewModal}
          close={handelCloseViewModal}
          fields={update_fields}
          modalTitle="View Password"
          obj={updateObject}
        />
      )}
      <Style.MainHeading>
        {/* <Style.HeaderImg src={Safe} alt="Safe"></Style.HeaderImg> */}
        <div style={{display:'flex', alignItems:'baseline', columnGap:'3px'}}>
          List of Passwords{" "}
          <ToolTipCreator name={"Death_List_of_Passwords"}/>
        </div>
        {/* <Style.HelpIcon
          src={helpIcon}
          alt="helpicon"
          onClick={() => {
            showTooltipModal();
          }}></Style.HelpIcon> */}
      </Style.MainHeading>
      <div
        style={{
          fontFamily: "Poppins",
          fontSize: "17px",
          textAlign: "center",
          color: "black",
          marginTop: "4px",
        }}>
        If newly added files are not showing, the One-Time Passcode may not have
        been entered correctly. Please log out, log back in and try again.
      </div>
      <Style.HealthCard>
        <Style.HealthCardHeader>
          <Style.Title style={{}}>
            Upload your Password Sheet (.pdf, .xls, .jpg, .numbers, etc.)
            {/* <Style.HelpIcon
            src={helpIcon}
            alt="helpicon"
            onClick={() => {
              // showHelpModal();
            }}
          ></Style.HelpIcon> */}
          </Style.Title>
          {props.role !== "protrustee" && props.role !== "trustee" && (
            <div>
              <input
                type="file"
                id="upload"
                hidden
                onChange={(event) => {
                  handleImageUpload(event);
                }}
                accept="image/jpeg, .pdf, .xlsx, .doc,.csv,.numbers"
              />
              <Style.Button
                for="upload"
                onClick={() => {
                  setDropdown(false);
                }}>
                +
              </Style.Button>
              {/*<Style.Button>+</Style.Button> */}
            </div>
          )}
        </Style.HealthCardHeader>
        <Style.FileHeader>
          <Style.FileTitle style={{ display: "flex" }}>
            <a
              style={{ color: "#7d8fb3" }}
              href={fileUpload && fileUpload.clientPasswordDocument}
              target="blank">
              {" "}
              {fileUpload && fileUpload.clientPasswordFileName
                ? fileUpload.clientPasswordFileName
                : ""}{" "}
            </a>
            <div style={{ color: "#7d8fb3", marginLeft: "2rem" }}>
              {" "}
              {fileUpload &&
                fileUpload.clientPasswordDate &&
                moment(fileUpload.clientPasswordDate).format("MM-DD-YYYY")}{" "}
            </div>
          </Style.FileTitle>
          {fileUpload && fileUpload.clientPasswordDocument && (
            <React.Fragment>
              <img
                style={{ cursor: "pointer", marginLeft: "8px" }}
                src={SeeMore}
                alt="seemore"
                onClick={() => {
                  setDropdownFile(!dropdownFile);
                }}></img>
              {dropdownFile && (
                <>
                  <div
                    onClick={() => {
                      setDropdownFile(false);
                    }}
                    className=""
                    style={{
                      position: "fixed",
                      width: "100vw",
                      height: "100vh",
                      background: "black",
                      opacity: "0.1",
                      top: "0",
                      left: "0",
                      right: "0",
                      bottom: "0",
                      zIndex: "999",
                    }}></div>

                  <div
                    className="dropdown"
                    style={{
                      marginTop: "1rem",
                      width: "230px",
                      zIndex: "9999",
                    }}>
                    <ul
                      className="dropdownul"
                      style={{
                        fontSize: "12px",
                        fontFamily: "Poppins",
                        width: "230px",
                      }}>
                      {props.role !== "protrustee" &&
                        props.role !== "trustee" && (
                          <li
                            className="liHover"
                            onClick={async () => {
                              handleRemoveFile();
                              setDropdownFile(false);
                            }}>
                            Delete
                          </li>
                        )}
                      <li
                        className="liHover"
                        onClick={async () => {
                          setDropdownFile(false);
                        }}>
                        <a
                          // style={{ color: "#4D4F5C", width: "230px" }}
                          href={fileUpload.clientPasswordDocument}
                          target="blank">
                          {" "}
                          <div style={{ width: "230px" }}>
                            {fileUpload && "View"}{" "}
                          </div>
                        </a>
                      </li>
                    </ul>
                  </div>
                </>
              )}
            </React.Fragment>
          )}
        </Style.FileHeader>
        {/*filesList.map((item, index) => (
        <Style.FileHeader key={index}>
          <Style.FileTitle style={{}}>{item.fileName}</Style.FileTitle>
        </Style.FileHeader>
      )) */}
      </Style.HealthCard>
      <Style.HealthCard>
        <Style.HealthCardHeader>
          <Style.Title style={{}}>Passwords</Style.Title>
          {props.role !== "protrustee" && (
            <div>
              <Style.Button
                onClick={() => {
                  // setShowAddModal(true);
                  setDropDownPassword(!dropDownPassword);
                }}>
                +
              </Style.Button>
              {dropDownPassword && (
                <>
                  <div
                    onClick={() => {
                      setDropDownPassword(false);
                    }}
                    className=""
                    style={{
                      position: "fixed",
                      width: "100vw",
                      height: "100vh",
                      background: "black",
                      opacity: "0.1",
                      top: "0",
                      left: "0",
                      right: "0",
                      bottom: "0",
                      zIndex: "999",
                    }}></div>
                  <div
                    class="dropdown"
                    style={{
                      width: "250px",
                      fontSize: "12px",
                      fontFamily: "Poppins",
                      zIndex: "9999",
                    }}>
                    <ul className="dropdownul">
                      <li
                        className="liHover"
                        onClick={() => {
                          setShowAddModal(true);
                          setDropDownPassword(false);
                        }}>
                        Add Password
                      </li>
                      <li
                        className="liHover"
                        onClick={() => {
                          downloadTemplate();
                          setDropDownPassword(false);
                        }}>
                        Download Template
                      </li>
                      <li
                        className="liHover"
                        onClick={() => {
                          openFileRef();
                          setDropDownPassword(false);
                        }}>
                        Upload Password sheet
                      </li>
                      {listofPassword && listofPassword.length > 0 && (
                        <li
                          className="liHover"
                          onClick={() => {
                            downloadFileRef();
                            setDropDownPassword(false);
                          }}>
                          Download Password Sheet
                        </li>
                      )}
                    </ul>
                  </div>
                </>
              )}{" "}
            </div>
          )}
        </Style.HealthCardHeader>
        <List cols={cols} rows={listofPassword}></List>
      </Style.HealthCard>
      <div
        style={{
          display: "flex",
          background: "white",
          borderRadius: "8px",
          overflow: "hidden",
          marginTop: "1rem",
          justifyContent: "center",
        }}>
        <div style={{ fontSize: "20px", padding: "1rem" }}>
          Advertising Space
        </div>
      </div>
      <Loader isLoading={loading} />
    </div>
  );
};
